import { useEffect } from "react";
import { Box } from "@dealer-center/core-components";
import { mockNrtMappingRecords } from "./mockData";
import { Header } from "./Display/Header";
import { RecordsTable } from "./Display/RecordsTable";

const PAGE_TITLE = "NRT Mapping Tool";

export const PagesNrtDatabaseFilterToolUi = () => {
  useEffect(() => {
    document.title = PAGE_TITLE;
  }, []);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
      <Header
        subtitle="View, edit, and manage data mappings"
        title={PAGE_TITLE}
      />
      <RecordsTable records={mockNrtMappingRecords} />
    </Box>
  );
};
